module.exports = __webpack_public_path__ + "static/media/mail-chimp-logo.d0add231.png";